import { RetryManager } from 'features/utils/helpers';

export const SIGNALR_RECONNECT = {
  MAX_RETRIES: 4,
  BASE_DELAY: 500,
  MAX_DELAY: 10000,
};

/**
 * Generates an array of delay times (in milliseconds) for RNS SignalR reconnection attempts.
 * Implements an exponential backoff strategy with random jitter using the RetryManager.
 */
export const generateSignalRReconnectDelays = (): number[] => {
  const retryManager = RetryManager.withJitter(
    SIGNALR_RECONNECT.BASE_DELAY,
    SIGNALR_RECONNECT.MAX_RETRIES
  );

  // Create an array with a length equal to the maximum number of retries.
  return Array.from({ length: SIGNALR_RECONNECT.MAX_RETRIES }, (_, index) => {
    // Use RetryManager's internal delay calculation (accessing private method for this utility)
    const attemptNumber = index + 1;
    return (retryManager as any).calculateDelay(attemptNumber);
  });
};
